import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@cfp/core';
import { LoadingSpinner } from '@cfp/ui/common';

@Component({
  selector: 'cfp-logout-page',
  templateUrl: './logout.page.html',
  imports: [LoadingSpinner],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutPage {
  private readonly authService = inject(AuthService);

  protected loading: boolean = true;

  constructor() {
    this.authService.logoutServerSideAndRedirect();
  }
}
